import { Injectable, inject } from '@angular/core';
import { DialogService } from '@ngneat/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectionDialogComponent, SelectionDialogData, SelectionDialogResult } from '../../components/dialogs/selection-dialog/selection-dialog.component';
import { MessageDialogComponent } from '../../components/dialogs/message-dialog/message-dialog.component';
import { MessageDialogData } from '../../interfaces/dialog';
import { Selection } from '../../interfaces/selection';

@Injectable({ providedIn: 'root' })
export class SelectionDialogService {
  private dialogService = inject(DialogService);

  openAddDialog(): Observable<SelectionDialogResult | undefined> {
    const dialogRef = this.dialogService.open(SelectionDialogComponent, {
      data: { mode: 'add' } as SelectionDialogData,
    });

    return dialogRef.afterClosed$;
  }

  openEditDialog(selection: Selection): Observable<SelectionDialogResult | undefined> {
    const dialogRef = this.dialogService.open(SelectionDialogComponent, {
      data: { mode: 'edit', selection } as SelectionDialogData,
    });

    return dialogRef.afterClosed$;
  }

  confirmDelete(selectionName: string): Observable<boolean> {
    const safeName = selectionName.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const ref = this.dialogService.open(MessageDialogComponent, {
      data: {
        title: 'Delete selection',
        message: `Are you sure you want to delete "${safeName}"?`,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      } as MessageDialogData,
    });

    return ref.afterClosed$.pipe(map((confirmed) => !!confirmed));
  }
}
